import { render, staticRenderFns } from "./JustifyPriorityDialog.vue?vue&type=template&id=81bb41c0&"
import script from "./JustifyPriorityDialog.vue?vue&type=script&lang=js&"
export * from "./JustifyPriorityDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports